import React from 'react';
import { Box, TableCell, TableRow, Typography } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { COL_COUNT } from './checkinViewHelpers';

// Sticky offset for the group headers - must equal the column-name TableHead row
// height so the group header pins flush under it. Too large pushes the group header
// down and leaves a gap of table background below the column header.
const STICKY_TOP = 41;

const CheckinGroupHeader = ({ name, count, collapsed, onToggle }) => (
    <TableRow>
        <TableCell
            colSpan={COL_COUNT}
            onClick={onToggle}
            sx={{
                position: 'sticky',
                top: STICKY_TOP,
                zIndex: 2,
                backgroundColor: 'grey.200',
                cursor: 'pointer',
                py: 1,
                '&:hover': { backgroundColor: 'grey.300' },
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {collapsed ? <ExpandMore /> : <ExpandLess />}
                <Typography variant="subtitle2">{name}</Typography>
                <Typography variant="body2" color="text.secondary">
                    ({count})
                </Typography>
            </Box>
        </TableCell>
    </TableRow>
);

export default CheckinGroupHeader;
